module.exports = __webpack_public_path__ + "img/keyboard_hatsu.ee748392.png";